module.exports = __webpack_public_path__ + "static/media/plan3.fd84464c.jpg";